import { useTranslation } from 'react-i18next'

import { EXTERNAL_PATH } from 'lib/paths'

import { ExternalLink } from 'components'

import './style.scss'

const AnnouncementBanner = ({}) => {
  const { t } = useTranslation()

  const version = window?.gon?.version?.split('.').slice(0, -1).join('.')

  return (
    <div className="AnnouncementBanner">
      <ExternalLink
        className="AnnouncementBanner__a"
        href={EXTERNAL_PATH.RELEASE_NOTES()}
      >
        <div className="AnnouncementBanner__a__text">
          <h1>Ver. {version}</h1>
          <h2>{t('announcement_banner.update_information')}</h2>
        </div>
      </ExternalLink>
    </div>
  )
}

export default AnnouncementBanner
